class openedRelatedBillCtrl {
    constructor($scope, logger, httpRequest, $state) {
        const _waitId = $state.params.invoiceId
        if (_waitId === 'undefined') {
            $state.go('outputManage.fullElectricInvoice.openedFullEleInvoice.list')
        }

        httpRequest.get_dictByTypeArr(['inv_type', 'tax_includ', 'bill_status']).then((res) => {
            $scope.dictData = Object.assign($scope.dictData, res.data.value)
            $scope.invTypeList = $scope.dictData.inv_type
        })
        const queryOvatBillList = function () {
            const req = {
                pageNum: $scope.currentPage,
                pageSize: $scope.maxSize,
                param: _waitId,

            }
            httpRequest.post_getInvoiceBillList(req).then((res) => {
                $scope.resData = res.data.value.list
                $scope.totalItems = res.data.value.total
                $scope.currentPage = ++res.data.value.prePage
                $scope.maxSize = res.data.value.pageSize
            })
        }
        // 分页
        $scope.totalItems = 0 // 组件初始化设置总页数
        $scope.currentPage = 1 // 设置显示第一页
        $scope.maxSize = 10 // 每一叶显示记录数
        // 页面跳转
        $scope.pageChanged = function () {
            queryOvatBillList()
        }
        queryOvatBillList()
        // 销售单明细
        $scope.toCheckPage = function (item) {
            if (item.billId === undefined || item.billId === null) {
                logger.logError('参数错误，请刷新重试')
            } else {
                const url = $state.href('outputManage.billManage.openedInvoice.checkBillDetail', {
                    billId: item.billId,
                }, { reload: true })
                window.open(url, '_blank')
            }
        }
        /**
         * 表相关的控制方法
         * 后期抽离成组件
         * 全选 / 排序 / 分页 / 选中行
         */

        // 表格固有方法功能 -未来抽象为datagrid 组件
        // $scope.rows = $scope.resData;
        // 全选状态
        $scope.tb_isAllselected = false
        // 表格行点击方法
        $scope.tb_rowClcik = function (...arg) {
            $scope.tb_rowSelect(...arg)
        }
        // 表格行checkSelect 方法
        $scope.tb_rowSelect = function (idx, row) {
            // 全选
            let len = 0
            for (let a = 0 ; a < $scope.resData.length; a++) {
                if ($scope.resData[a].selected == true) len++
            }
            if (len == $scope.resData.length) {
                $scope.tb_isAllselected = true
            } else {
                $scope.tb_isAllselected = false
            }
        }
        // 表格行划过
        $scope.tb_rowhover = function (row, flag) {
            row.mouseenter = flag
        }
        // 按钮滑过
        $scope.dropdown_rowhover = function (row, flag) {
            row.dropdownhover = flag
        }

        // 状态按钮滑过
        $scope.dropdown_rowhover_state = function (row, flag) {
            row.dropdowstatenhover = flag
        }
        // 表格全选
        $scope.tb_selectAll = function (val) {
            $scope.tb_isAllselected = val
            for (let a = 0 ; a < $scope.resData.length; a++) {
                $scope.resData[a].selected = $scope.tb_isAllselected
            }
        }
    }
}
openedRelatedBillCtrl.$inject = ['$scope', 'logger', 'httpRequest', '$state']
export default openedRelatedBillCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/openedFullEleInvoice/openedRelatedBillCtrl.js